import { SvgIcon, SxProps } from "@mui/material";
import Icon from "jsx:../../../Images/Icons/FontAwesome/regular/flag-checkered.svg";

export function FlagCheckeredClassicRegularIcon(props: SxProps) {
    return <SvgIcon component={Icon} inheritViewBox sx={props} />;
}
